import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormControllerService } from "src/app/services/form-controller/form-controller.service";

@Component({
  selector: "transform-grid",
  templateUrl: "./transform-grid.component.html",
  providers: [FormControllerService],
})
export class TransformGridComponent implements OnInit {

  @Input() public gridId: any;
  @Input() public distinctByFields: any[] = [];
  @Input() public groupByFields: any[] = [];
  @Input() public serviceId: string;
  public isDistinct: boolean = false;
  public isGroupBy: boolean = false;
  public typeTransformation: string = null;
  @Input() public inputTransformations: string[] = [];
  @Input() public gridTransformations: string[] = [];
  @Output() public updateTransformations: EventEmitter<any> = new EventEmitter();
  @Output() public updateDistinctByField: EventEmitter<any> = new EventEmitter();
  @Output() public updateGroupByField: EventEmitter<any> = new EventEmitter();

  public gridItems: any[] = [];

  constructor(
    public formControllerService: FormControllerService,
  ) { }

  public ngOnInit(): void {
    console.log(this.gridId, this.distinctByFields);
    if (this.distinctByFields.length) {
      this.typeTransformation = this.distinctByFields[0];
    }
    if (this.groupByFields.length) {
      this.typeTransformation = this.groupByFields[0];
    }
    if (this.inputTransformations.length && this.inputTransformations[0] === "distinctBy") {
      this.isDistinct = true;
    }
    if (this.inputTransformations.length && this.inputTransformations[0] === "groupBy") {
      this.isGroupBy = true;
    }
    if (this.gridId && this.serviceId) {
      this.formControllerService.getFormField(this.serviceId, this.gridId).subscribe(
        (data) => {
          // eslint-disable-next-line
          if (data["components"]) {
            // eslint-disable-next-line
            this.gridItems = data["components"];
          }
          console.log(data);
        },
        (error) => {
          console.log(error);
        },
      );
    }
  }

  public typeUpdate(type): void {
    this.inputTransformations = [];
    if (this.isDistinct && type === "distinct") {
      this.isGroupBy = false;
      this.inputTransformations.push("distinctBy");
    }
    if (this.isGroupBy && type === "groupBy") {
      this.isDistinct = false;
      this.inputTransformations.push("groupBy");
    }
    this.updateTransformations.emit(this.inputTransformations);
  }

  public fieldUpdate(): void {
    if (this.isDistinct) {
      this.distinctByFields = [];
      if (this.typeTransformation !== "null") {
        this.distinctByFields.push(this.typeTransformation);
      }
      this.updateDistinctByField.emit(this.distinctByFields);
    }
    if (this.isGroupBy) {
      this.groupByFields = [];
      if (this.typeTransformation !== "null") {
        this.groupByFields.push(this.typeTransformation);
      }
      this.updateGroupByField.emit(this.groupByFields);
    }
  }

}
